// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"aea3d50b","297":"389fbbd3","643":"8c47e128"}[chunkId] + ".js";
};